import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  PersistConfig,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { app } from '../configuration'

import { reducers } from './index'
import rootSaga from './sagas'

export const rootReducer = combineReducers(reducers) as any

export type RootState = ReturnType<typeof rootReducer>

// use this in your components when you need a typed version of useSelector() hook
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

const makeStore = (initialState: any = {}) => {
  const sagaMiddleware = createSagaMiddleware()

  const persistConfig: PersistConfig<any> = {
    key: 'root',
    version: 2,
    storage,
    blacklist: ['mail'],
  }

  const persistedReducer: any = persistReducer(persistConfig, rootReducer)

  const store = configureStore({
    reducer: persistedReducer as any,
    preloadedState: initialState as any,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  })

  const persistor = persistStore(store)

  if (!app.PERSIST_STORE_ENABLED) {
    persistor.pause()
    persistor.purge()
  }

  sagaMiddleware.run(rootSaga)

  return { store, persistor, sagaMiddleware }
}

export default makeStore()
